export default __webpack_public_path__ + "static/media/emoji-love.4196399a.svg";